module.exports = __webpack_public_path__ + "static/media/logout.f2ec87c8.svg";